import { formatRange } from '@util/index';
import { ProductDocument } from 'models/product';
import Link from 'next/link';
import { useRouter } from 'next/navigation';
export default function ProductConditions({
  product,
}: {
  product: ProductDocument;
}) {
  const router = useRouter();

  return (
    <div className="flex flex-col gap-y-4">
      <Item title="Condition" value={product.condition} />

      {['Casual', 'Gear'].some((x) =>
        product.category.toLowerCase().includes(x.toLowerCase())
      ) &&
        !product?.variations &&
        (product.size?.letter || !!product.size?.number) && (
          <Item
            title="Size"
            value={`${product.gender === 'Y' ? 'Youth ' : ''} ${
              product.size?.letter
                ? product.size?.letter
                : product.size?.number
                ? product.size?.number.toString()
                : ''
            }`}
          />
        )}
      {product.category2 === 'Tires' && product.size?.letter && (
        <Item
          title={`${product.size.letter1 ? 'Front ' : ''}Tire Size`}
          value={product.size.letter}
        />
      )}
      {product.category2 === 'Tires' && product.size?.letter1 && (
        <Item title="Rear Tire Size" value={product.size.letter1} />
      )}
    </div>
  );
}

const DeliveryItem = ({
  deliveryDates,
  isDigital,
}: {
  deliveryDates:
    | {
        earliest: string;
        latest: string;
      }
    | undefined;
  isDigital: boolean;
}) => {
  const showLoading = !deliveryDates;

  return (
    <div className="flex items-center gap-x-2">
      <span className="text-[1.8rem] font-semibold text-brand-black">
        Delivery:
      </span>

      <span className="flex items-center gap-x-2 text-[1.6rem] text-brand-black">
        {isDigital ? (
          <span className="font-semibold">Delivered Electronically</span>
        ) : (
          <>
            Get it by{' '}
            {showLoading ? (
              <div className="h-5 w-32 animate-pulse rounded-full bg-brand-light-gray" />
            ) : (
              <>
                <span className="font-semibold">
                  {formatRange(deliveryDates)}
                </span>
              </>
            )}{' '}
            if you order today!
          </>
        )}
      </span>
    </div>
  );
};

const Item = ({
  title,
  value,
  linkText,
  linkHref,
}: {
  title: string;
  value?: string;
  linkText?: string;
  linkHref?: string;
}) => {
  return (
    <div className="flex items-center gap-x-2">
      <span className="text-[1.8rem] font-semibold text-brand-black">
        {title}:
      </span>

      {linkHref ? (
        <Link
          href={linkHref}
          className="text-[1.6rem] text-brand-black underline"
        >
          {linkText}
        </Link>
      ) : (
        <span className="text-[1.6rem] text-brand-black">{value}</span>
      )}
    </div>
  );
};
